var regex = {
    digits: /^[0-9]+$/,
    digitsAndDash: /^[0-9]+([0-9-]+)?$/,
    nonDigit: /[^\d.,-]/g,
    digitsAndComma: /^[0-9,.]+$/,
    integer: /^-?\d*$/,
    integerPositive: /^\d*$/, // int >= 0
    floatValue: /^-?\d*[.,]?\d*$/,
    currency: /^-?\d*[.,]?\d{0,2}$/, // max two decimal places, e.g.: 24.33 / 24,33
    azonly: /^[a-z]*$/i,
    postalCode: "^[0-9]{4}(?:-[0-9]{3})?$",
    email: /^(([^<>()\[\]\\√#&@$%^*.,;:\s@"]+(\.[^<>()\[\]\\√#&@$%^*.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // eslint-disable-line
    coverageAreaPostalCode: /^\d{4}-\d{3}?/,
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
    isSafari: /Version\/[\d.]+.*Safari/,
    iosVersion: /OS (\d+)_(\d+)_?(\d+)?/,
    nonASCII: /[^\x00-\x7F]/g, //eslint-disable-line
    nonASCIIWithPTChars: /[^\x00-\x7F\u00C0-\u00E3\u00C7-\u00FC]/g, //eslint-disable-line
    voucherId: /^185[0-9]{5}$/,
    giftId: /^185[0-9]{15}$/,
    loyaltyCardNumber: /^185[0-9]{10}$|225[0-9]{10}$/,
    cartaoDaCardNumber: /^1111[0-9]{15}$/,
    companyCode: /[a-zA-Z0-9]+$/,
    taxNumber: /[0-9]+$/,
    companyName: /^(?!.*\s{2,})[A-Za-zÀ-ÖØ-öø-ÿ0-9&.,ºª\- ]{2,100}$/,
    loyaltyCardSecurityCode: /[0-9]{6}$/,
    postalCodeRegex: /^[0-9]{4}(?:-[0-9]{3})?$/,
    XSSRegex: /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi
};

module.exports = {
    values: regex
};
